import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';

export default function GoogleLoginButton({ onNewUser, onExistingUser, selectedRole, onRoleSelect }) {
  const [error, setError] = useState('');

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    setError('');
    
    try {
      // credentialResponse contains 'credential' (the ID token)
      const credential = credentialResponse.credential;

      if (!credential) {
        setError('Failed to get Google credential');
        return;
      }

      // First, check if user exists
      const response = await axios.post('/api/auth/google-login', { credential });

      if (response.data.isNewUser) {
        // New user - trigger role selection modal and pass credential
        onNewUser({
          ...response.data,
          credential, // Pass credential to modal
        });
      } else {
        // Existing user - auto-login
        onExistingUser(response.data);
      }
    } catch (err) {
      console.error('Google login error:', err);
      setError(err.response?.data?.message || 'Google login failed. Please try again.');
    }
  };

  const handleGoogleLoginError = () => {
    setError('Google login failed. Please try again.');
  };

  return (
    <div className="google-login-button-container">
      <GoogleLogin
        onSuccess={handleGoogleLoginSuccess}
        onError={handleGoogleLoginError}
        text="signin_with"
        size="large"
        width="100%"
      />
      {error && (
        <div style={{ color: '#d32f2f', fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
          {error}
        </div>
      )}
    </div>
  );
}
